import React from "react";

function HeadSet() {
  return (
    <div className="headset">
      <svg width="18px" height="22px" viewBox="0 0 18 22" version="1.1">
        <title>headset_mic</title>
        <desc>Created with Sketch.</desc>
        <g
          id="Icons"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g id="Outlined" transform="translate(-681.000000, -2459.000000)">
            <g id="Hardware" transform="translate(100.000000, 2404.000000)">
              <g
                id="Outlined-/-Hardware-/-headset_mic"
                transform="translate(578.000000, 54.000000)"
              >
                <g>
                  <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
                  <path
                    d="M19,14 L19,18 L17,18 L17,14 L19,14 Z M7,14 L7,18 L6,18 C5.45,18 5,17.55 5,17 L5,14 L7,14 Z M12,1 C7.03,1 3,5.03 3,10 L3,17 C3,18.66 4.34,20 6,20 L9,20 L9,12 L5,12 L5,10 C5,6.13 8.13,3 12,3 C15.87,3 19,6.13 19,10 L19,12 L15,12 L15,20 L19,20 L19,21 L12,21 L12,23 L18,23 C19.66,23 21,21.66 21,20 L21,10 C21,5.03 16.97,1 12,1 Z"
                    id="🔹-Icon-Color"
                    fill="#1D1D1D"
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
}

export default HeadSet;
